module.exports = __webpack_public_path__ + "static/media/principios.0392b00f.jpg";